"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconChartNew = Experimental__IconChartNew;
exports.IconChartNew = IconChartNew;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * @deprecated IconChartNew is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function IconChartNew(props) {
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M13.15 8.325l-1.182.786a.884.884 0 00-.31.4.869.869 0 00-.063.505l.278 1.397c.032.159.003.283-.087.373-.09.09-.214.119-.373.087l-1.397-.278a.86.86 0 00-.504.064.86.86 0 00-.4.31l-.787 1.182c-.09.132-.198.198-.325.198s-.235-.066-.325-.198l-.786-1.183a.884.884 0 00-.4-.31.869.869 0 00-.505-.063l-1.397.278c-.159.032-.283.003-.373-.087-.09-.09-.119-.214-.087-.373l.278-1.397a.86.86 0 00-.064-.504.86.86 0 00-.31-.4L2.85 8.324c-.133-.09-.199-.197-.199-.324s.066-.235.198-.325l1.183-.786a.884.884 0 00.31-.4.868.868 0 00.063-.505l-.278-1.397c-.032-.159-.003-.283.087-.373.09-.09.214-.119.373-.087l1.397.278a.86.86 0 00.504-.064.86.86 0 00.4-.31l.787-1.182c.09-.132.198-.198.325-.198s.235.066.325.198l.786 1.183c.09.132.223.235.4.31a.868.868 0 00.505.063l1.397-.278c.159-.032.283-.003.373.087.09.09.119.214.087.373l-.278 1.397a.86.86 0 00.064.504.86.86 0 00.31.4l1.182.787c.132.09.198.198.198.325s-.066.235-.198.325h-.001z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M19.725 12.488l-1.773 1.179a1.326 1.326 0 00-.465.6 1.31 1.31 0 00-.095.757l.418 2.096c.048.238.004.424-.131.56-.135.134-.321.178-.56.13l-2.095-.417a1.29 1.29 0 00-.756.096 1.29 1.29 0 00-.6.465l-1.18 1.773c-.136.198-.298.297-.488.297s-.352-.1-.488-.297l-1.178-1.775a1.326 1.326 0 00-.6-.465 1.302 1.302 0 00-.758-.094l-2.096.417c-.237.048-.424.004-.559-.13-.135-.136-.178-.322-.13-.56l.417-2.096a1.29 1.29 0 00-.096-.756 1.29 1.29 0 00-.465-.6l-1.772-1.182c-.199-.134-.299-.296-.299-.486s.1-.352.298-.487l1.774-1.18c.198-.134.353-.334.465-.6.11-.266.141-.519.095-.757L6.19 6.881c-.048-.238-.005-.425.13-.56.135-.135.322-.178.56-.13l2.095.417c.238.047.49.015.756-.096a1.29 1.29 0 00.6-.465l1.18-1.773c.136-.198.298-.297.488-.297s.352.099.488.297l1.178 1.774c.136.198.335.353.6.465.268.11.52.142.758.095l2.095-.417c.239-.048.425-.005.56.13.135.135.179.322.13.56l-.417 2.095a1.29 1.29 0 00.096.756c.11.266.265.466.465.6l1.774 1.18c.197.136.296.298.296.488s-.099.353-.296.488h-.002z\'/>'
  }];
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = props.autoMirror || false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated IconChartNew is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function Experimental__IconChartNew(props) {
  return /*#__PURE__*/_react["default"].createElement(IconChartNew, props);
}